// Translation
import { useTranslation } from "react-i18next";

// Components
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogTitle,
  DialogContentText,
} from "@mui/material";

// Styles
import { styles } from "./styles";

export const ErrorDialog = ({ open, onClose, errorMessage }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{ paper: { sx: styles.dialogPaper } }}
    >
      <DialogTitle sx={styles.errorTitle}>{t("errorDialog.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{errorMessage}</DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="contained" onClick={onClose} sx={{ width: "125px" }}>
          {t("errorDialog.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
